import moment from "moment";
import React from "react";
import BootstrapTable from "react-bootstrap-table-next";
import "react-bootstrap-table-next/dist/react-bootstrap-table2.min.css";
import { AiOutlineEdit } from "react-icons/ai";
import { FaMinusCircle } from "react-icons/fa";
import { FiEye } from "react-icons/fi";
import { NavLink } from "react-router-dom";
import { useAppSelector } from "../../../../redux/store";
import { useProjetsByUserQuery } from "../../../../utils/api/launchCampagn/projet.api";
import { formatAmout } from "../../../../utils/utils";
import { getRoutePath } from "../../../routes/routes";
import { DeleteProjetButton } from "../../TableauDeBord/mesprojets/DetailsProjet/DetailsProjet";
import DebitModal from "../../../modales/DebitModal";
import ListeProjetsSkeleton from "./ListeProjetsSkeleton";

function MesProjetsTable() {
  const userId = useAppSelector((s) => s.user.user?.id as number);
  const [page, setPage] = React.useState(1);
  const { data = { results: [] }, isLoading } = useProjetsByUserQuery({
    page,
    id: userId,
  });
  const etatFormat = (cell: any, row: any) => {
    const status = {
      // Le statut dit la validation par l'admin (seul un projet valide
      // recoit de l'argent) ; la visibilite, choisie par le porteur, est
      // affichee dessous. « En ligne / Hors ligne » les confondait.
      online: { class: "etat-projet-en-ligne", text: "Validé" },
      offline: { class: "etat-projet-hors-ligne", text: "En attente de validation" },
      termine: { class: "etat-projet-en-termine", text: "Terminé" },
    };
    const obj = status[cell] || status.offline;
    return (
      <>
        <div className={obj.class}>
          <span className="text-statut-format">{obj.text}</span>
        </div>
        <div style={{ fontSize: 11, color: "rgba(0,0,0,0.55)", marginTop: 4 }}>
          {row?.visibilite === "prive" ? "Privé · par lien" : "Public"}
        </div>
      </>
    );
  };

  const actionFormatter: any = (cell, row) => {
    const modalDebitId = `ModalDebit${row.id}`;
    return (
      <div className="table-actions-btn-container-projet">
        <NavLink
          className="btn tb-action-btn tb-action-btn-voir"
          title="Voir la page telle que la voient les contributeurs"
          state={row}
          to={getRoutePath("CampainsDetails", { slug: row.slug })}
        >
          <FiEye /> Voir
        </NavLink>
        <button
          type="button"
          className="btn tb-action-btn tb-action-btn-retirer"
          title="Demander un retrait"
          data-bs-toggle="modal"
          data-bs-target={`#${modalDebitId}`}
          disabled={Number(row?.montant_total_restant || 0) <= 0}
        >
          <FaMinusCircle /> Retirer
        </button>

        <DebitModal modalId={modalDebitId} projet={row} />
        <DeleteProjetButton
          modalId={`DeleteProject${row.id}`}
          item={row}
          className="page-detail-projet-tab-icon"
          iconClassName={`supprimer-btn`}
        />

        <NavLink
          to={getRoutePath("UpdateCampain", { slug: row.slug })}
          state={row}
          className="action-btn "
        >
          <AiOutlineEdit className="edit-btn" />
        </NavLink>
      </div>
    );
  };

  const columns = [
    {
      dataField: "name",
      text: "Nom",
      // Le nom mene a la gestion du projet (retraits, historique) : l'oeil
      // est desormais reserve a l'apercu contributeur.
      formatter: (cell: any, row: any) => (
        <NavLink
          to={getRoutePath("DetailsProjet", { slug: row.slug })}
          state={row}
          title="Gérer le projet"
          style={{ color: "inherit", textDecoration: "underline" }}
        >
          {cell}
        </NavLink>
      ),
      style: {
        textAlign: "center",
        color: "rgba(0, 0, 0, 0.7)",
        fontFamily: "Poppins",
        fontSize: "14px",
        fontWeight: "500",
      },
      headerStyle: {
        textAlign: "center",
        color: "rgba(0, 0, 0, 0.7)",
        fontFamily: "Poppins",
        fontSize: "14px",
        fontWeight: "700",
      },
    },
    {
      dataField: "date_debut",
      formatter: (cell) => (cell && moment(cell).isValid() ? moment(cell).format("DD/MM/YYYY") : "—"),
      text: "Date de début",
      style: {
        textAlign: "center",
        color: "rgba(0, 0, 0, 0.7)",
        fontFamily: "Poppins",
        fontSize: "14px",
        fontWeight: "500",
      },
      headerStyle: {
        textAlign: "center",
        color: "rgba(0, 0, 0, 0.7)",
        fontFamily: "Poppins",
        fontSize: "14px",
        fontWeight: "700",
      },
    },
    {
      dataField: "date_fin",
      formatter: (cell) => (cell && moment(cell).isValid() ? moment(cell).format("DD/MM/YYYY") : "—"),
      text: "Date de fin",
      style: {
        textAlign: "center",
        color: "rgba(0, 0, 0, 0.7)",
        fontFamily: "Poppins",
        fontSize: "14px",
        fontWeight: "500",
      },
      headerStyle: {
        textAlign: "center",
        color: "rgba(0, 0, 0, 0.7)",
        fontFamily: "Poppins",
        fontSize: "14px",
        fontWeight: "700",
      },
    },
    {
      dataField: "statut",
      text: "Etat actuel",
      formatter: (cell: any, row: any) => etatFormat(cell, row),
      style: {
        textAlign: "center",
        color: "rgba(0, 0, 0, 0.7)",
        fontFamily: "Poppins",
        fontSize: "14px",
        fontWeight: "500",
      },
      headerStyle: {
        textAlign: "center",
        color: "rgba(0, 0, 0, 0.7)",
        fontFamily: "Poppins",
        fontSize: "14px",
        fontWeight: "700",
      },
    },
    {
      dataField: "funds",
      formatter: (cell) => formatAmout(cell),
      text: "Collectés",
      style: {
        textAlign: "center",
        color: "rgba(0, 0, 0, 0.7)",
        fontFamily: "Poppins",
        fontSize: "14px",
        fontWeight: "500",
      },
      headerStyle: {
        textAlign: "center",
        color: "rgba(0, 0, 0, 0.7)",
        fontFamily: "Poppins",
        fontSize: "14px",
        fontWeight: "700",
      },
    },
    {
      dataField: "montant_total_restant",
      formatter: (cell) => formatAmout(cell),
      text: "Disponible",
      style: {
        textAlign: "center",
        color: "rgba(0, 0, 0, 0.7)",
        fontFamily: "Poppins",
        fontSize: "14px",
        fontWeight: "500",
      },
      headerStyle: {
        textAlign: "center",
        color: "rgba(0, 0, 0, 0.7)",
        fontFamily: "Poppins",
        fontSize: "14px",
        fontWeight: "700",
      },
    },
    {
      dataField: "montant_total_debit",
      formatter: (cell) => formatAmout(cell),
      text: "Débités",
      style: {
        textAlign: "center",
        color: "rgba(0, 0, 0, 0.7)",
        fontFamily: "Poppins",
        fontSize: "14px",
        fontWeight: "500",
      },
      headerStyle: {
        textAlign: "center",
        color: "rgba(0, 0, 0, 0.7)",
        fontFamily: "Poppins",
        fontSize: "14px",
        fontWeight: "700",
      },
    },
    {
      dataField: "action",
      text: "Action",
      formatter: (cell: any, row: any) => actionFormatter(cell, row),
      style: {
        textAlign: "center",
        color: "rgba(0, 0, 0, 0.7)",
        fontFamily: "Poppins",
        fontSize: "14px",
        fontWeight: "500",
      },
      headerStyle: {
        textAlign: "center",
        color: "rgba(0, 0, 0, 0.7)",
        fontFamily: "Poppins",
        fontSize: "14px",
        fontWeight: "700",
      },
    },
  ];

  return (
    <>
      {isLoading && <ListeProjetsSkeleton />}
      {!isLoading && (
        <BootstrapTable
          keyField="id"
          data={data.results}
          columns={columns}
          // striped
          bordered={false}
          condensed={false}
          responsive
          wrapperClasses="table-responsive"
          // expandRow={ expandRow }
        />
      )}
    </>
  );
}

export default MesProjetsTable;
